export default __webpack_public_path__ + "22f8bcd1a7e85a271b23ea2d0e62102c.svg";